// FNP-1248 — labels and basePath every navigate/link in the module references,
// so a route rename is one edit rather than a grep.
export default {
    entityKey: 'provider-connections',
    basePath: '/provider-connections',
    titles: {
        singular: 'Provider Connection',
        plural: 'Provider Connections',
    },
};
